import { render, staticRenderFns } from "./PFOverview.vue?vue&type=template&id=d5f2dcc8"
import script from "./PFOverview.vue?vue&type=script&lang=js"
export * from "./PFOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports